import { render, staticRenderFns } from "./AssetsList.vue?vue&type=template&id=db2c3e20&"
import script from "./AssetsList.vue?vue&type=script&lang=ts&"
export * from "./AssetsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports